import { render } from "./app.vue?vue&type=template&id=79ee4984"
import script from "./app.vue?vue&type=script&setup=true&lang=js"
export * from "./app.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "C:\\essoduke\\Web\\health-click.dev\\app\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/assets/js/hcv2/vue/views/campaign/luckybox/app.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79ee4984"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79ee4984', __exports__)) {
    console.log('reload')
    api.reload('79ee4984', __exports__)
  }
  
  module.hot.accept("./app.vue?vue&type=template&id=79ee4984", () => {
    console.log('re-render')
    api.rerender('79ee4984', render)
  })

}


export default __exports__